import { FC, useEffect, useState } from 'react';
import './Unauthorized.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useStyle } from '../../providers/StyleProvider';
import { useAuth } from '../../providers/AuthProvider';

interface UnauthorizedProps { }

const Unauthorized: FC<UnauthorizedProps> = () => {
  const { urlDomus } = useStyle();
  const { tokenLacqua } = useAuth();
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    const message = sessionStorage.getItem("unauthorizedMessage") ||
      "Você não possui permissão para acessar essa página, entre em contato com a área comercial para solicitar o acesso.";
    setErrorMessage(message);

    sessionStorage.removeItem("unauthorizedMessage");
  }, []);

  return (
    <main className="Unauthorized main-content mt-0" data-testid="Unauthorized">
      <div className="page-header min-vh-100">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={7} className="mx-auto text-center">
              <h1 className="display-1 text-bolder text-primary"><i className='fas fa-lock'></i></h1>

              <h2>Acesso não autorizado</h2>
              <p className="lead">{errorMessage}</p>

              <a href={(urlDomus && tokenLacqua) ? `${urlDomus}/app/api/v1/auth/authTokenSB?token=${tokenLacqua}` : `${process.env.REACT_APP_DOMUS_DEV}`}>
                <Button className="btn btn-primary text-white mt-4 fadeIn2 fadeInBottom">Voltar para o login</Button>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </main>
  );
}

export default Unauthorized;
